import { render } from "./DicasPasseiosXP.vue?vue&type=template&id=fdfc7ff8&scoped=true&lang=pug"
import script from "./DicasPasseiosXP.vue?vue&type=script&setup=true&lang=js"
export * from "./DicasPasseiosXP.vue?vue&type=script&setup=true&lang=js"

import "./DicasPasseiosXP.vue?vue&type=style&index=0&id=fdfc7ff8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfc7ff8"]])

export default __exports__